import React, { forwardRef } from 'react';
import { classNames } from '@panwds/tailwindcss';

/**
 * A styled radio input
 */
const RadioInput = forwardRef((props, ref) => {
    const { isError, dataMetrics, dataTestId, addClassName, onChange, readOnly, ...rest } = props;
    return (React.createElement("input", { className: classNames(addClassName, 'tw-border-solid tw-form-radio tw-h-4 tw-w-4 tw-text-link tw-border tw-border-gray-300', 'dark:tw-bg-gray-1000 dark:tw-border-gray-700', 'focus:tw-custom-ring-offset-1 hover:tw-custom-ring-blue-200 focus:tw-ring-blue-200 dark:tw-ring-blue-800', isError && !props.disabled && 'tw-border-red-700 dark:tw-border-red-400', props.disabled ? 'tw-bg-gray-100' : 'hover:tw-custom-ring hover:tw-ring tw-cursor-pointer'), "data-metrics": dataMetrics, "data-testid": dataTestId, onChange: onChange, readOnly: readOnly, ...rest, type: "radio", ref: ref }));
});
RadioInput.displayName = 'RadioInput';

export { RadioInput };
//# sourceMappingURL=RadioInput.esm.js.map
